import { useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import { GET_BOOK_CONTENT_PAGINATION } from "../Schema/BookContent";

const useGetBookContentPagination = ({ bookId }) => {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [keyword, setKeyword] = useState("");
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [paginationData, setPaginationData] = useState();

  const { error, refetch } = useQuery(GET_BOOK_CONTENT_PAGINATION, {
    variables: {
      page,
      limit,
      pagination: true,
      keyword: keyword ?? "",
      bookId: bookId ? bookId : "",
    },
    onCompleted: ({ getBookContentPagination }) => {
      setTableData(getBookContentPagination?.data);
      setPaginationData(getBookContentPagination?.paginator);
      setLoading(false);
    },
  });

  useEffect(() => {
    if (error) {
      console.error("Error fetching lesson:", error.message);
    }
  }, [error]);

  const handleSearch = (e) => {
    setPage(1);
    setKeyword(e.target.value);
  };

  const handleLimit = (e) => {
    setLimit(Number(e.target.value));
    setPage(1);
  };

  return {
    page,
    limit,
    setPage,
    refetch,
    loading,
    setLoading,
    error,
    handleSearch,
    tableData,
    paginationData,
    handleLimit,
  };
};

export default useGetBookContentPagination;
